function formatPrice(price) {
  const value = price / 100
  return `${value.toFixed(2)}$`
}

function handleize(str = "") {
  return str
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
}

function renderStars(rating = 0) {
  const full = Math.floor(rating)
  const half = rating - full >= 0.5
  const drawn = full + (half ? 1 : 0)
  const empty = 5 - drawn

  let html = ""

  for (let i = 0; i < full; i++) {
    html += `<div class="svc-ico svc-ico--star"></div>`
  }

  if (half) {
    html += `<div class="svc-ico svc-ico--star-half"></div>`
  }

  for (let i = 0; i < empty; i++) {
    html += `<div class="svc-ico svc-ico--star-empty"></div>`
  }

  return html
}

function renderVariants(variants = []) {
  return variants.map(v => `
    <button class="svc-card__variant" data-id="${v.id}" data-price="${v.price}">
      ${v.title}
    </button>
  `).join("")
}

function renderSubproducts(subproducts = [], cardType = "default") {
  return subproducts.map(sp => `
    <button
      class="svc-card__subproduct"
      data-title="${sp.title}"
      data-variants='${JSON.stringify(sp.variants).replace(/"/g, '&quot;')}'
    >
      <span class="svc-card__subproduct-title">${sp.title}</span>
      ${cardType !== "default" ? `<span class="svc-card__subproduct-price"></span>` : ""}
    </button>
  `).join("")
}

function renderCard(product) {
  const classes = [
    "svc-card",
    product.handle,
    ...(product.collections || []).map(c => handleize(c.title))
  ].filter(Boolean).join(" ")

  const card = document.createElement("div")

  card.className = classes
  card.dataset.cardType = product.card_type
  card.dataset.collection = product.collection || ""

  if (product.card_type === "variants" || product.card_type === "instant") {
    card.dataset.variants = JSON.stringify(product.variants || [])
  }

  const badges = `
    ${product.exclusive ? `<span class="svc-card__badge svg-card__badge--exlusive">Exclusive</span>` : ""}
    ${product.is_best_seller ? `<span class="svc-card__badge svg-card__badge--bestseller">${window.translations.product.best_seller}</span>` : ""}
    ${product.is_sale ? `<span class="svc-card__badge svg-card__badge--sale">${window.translations.product.sale}</span>` : ""}
  `

  const rating = product.review_count > 0
    ? `
      <div class="svc-card__rating">
        ${renderStars(product.average_rating)}
        <span>(${product.review_count})</span>
      </div>
    `
    : ""

  const screen1 = `
    <div class="svc-card__screen svc-card__screen--1 is-active">
      <div class="svc-card__header svc-card__header--screen-1">

        <div class="svc-card__badges">
          ${badges}
        </div>

        <div class="svc-card__image"></div>

        <a href="${product.url}" class="svc-card__title">
          ${product.title}
        </a>

        ${product.card_type === "default" && product.subproducts_count > 1
      ? `<div class="svc-card__types-count">${product.subproducts_count} ${window.translations.product.types}</div>`
      : ""
    }

        ${rating}

      </div>

      <div class="svc-card__footer">

        ${product.card_type === "simple"
      ? `
            <div class="svc-card__price-label"></div>
            <div class="svc-card__price">${formatPrice(product.price)}</div>

            <form class="svc-card__form">
              <input type="hidden" name="id" value="${product.variants?.[0]?.id || ""}">
              <input type="hidden" name="product_title" value="${product.title}">
              <input type="hidden" name="variant_title" value="${product.variants?.[0]?.title || ""}">
              <input type="hidden" name="price" value="${product.price}">
              <input type="hidden" name="quantity" value="1">
              <input type="hidden" name="collection" value="${product.collection || ""}">

              <button type="button" class="svc-card__buy add_to_cart_button btn btn-primary">
                ${window.translations.product.add_to_cart}
                <div class="svc-ico svc-ico--arrow"></div>
              </button>
            </form>
          `
      : `
            <div class="svc-card__price-label">${window.translations.product.from}</div>
            <div class="svc-card__price">${formatPrice(product.price_min)}</div>

            <button class="svc-card__choose btn btn-primary">
              ${window.translations.product.choose_package}
              <div class="svc-ico svc-ico--arrow"></div>
            </button>
          `
    }

      </div>
    </div>
  `

  const screen2 = (product.card_type === "default" || product.card_type === "variants")
    ? `
      <div class="svc-card__screen svc-card__screen--2">
        <div class="svc-card__header svc-card__header--back">
          <div class="svc-card__service-ico"></div>
          <div class="svc-card__header-title"></div>
          <button class="svc-card__back">
            <div class="svc-ico svc-ico--close"></div>
          </button>
        </div>

        ${product.card_type === "default"
      ? `
            <div class="svc-card__subproduct-box">
              <div class="svc-card__subproduct-label">${window.translations.product.choose_option}</div>

              <button class="svc-card__subproduct-select">
                <span class="svc-card__subproduct-name">Select package</span>
              </button>
            </div>
          `
      : ""
    }

        <div class="svc-card__variants-box">
          <div class="svc-card__variants-label">${window.translations.product.quantity}</div>
          <div class="svc-card__variants">
            ${renderVariants(product.variants || [])}
          </div>
        </div>

        <div class="svc-card__form-box">
          <div class="svg-card__form-box-header">

            <div class="svg-card__input-quantity">
              <button class="svg-card__quantity-btn svg-card__quantity-btn--minus">
                <div class="svc-ico svc-ico--minus"></div>
              </button>

              <input type="text" name="quantity" value="1" class="svg-card__quantity-input">

              <button class="svg-card__quantity-btn svg-card__quantity-btn--plus">
                <div class="svc-ico svc-ico--plus"></div>
              </button>
            </div>

            <div class="svc-card__price svc-card__price--2">$0</div>

          </div>

          <form class="svc-card__form">
            <input type="hidden" name="id">
            <input type="hidden" name="product_title">
            <input type="hidden" name="variant_title">
            <input type="hidden" name="price">
            <input type="hidden" name="compare_at_price">
            <input type="hidden" name="quantity" value="1">
            <input type="hidden" name="collection" value="${product.collection || ""}">

            <button type="button" class="svc-card__buy add_to_cart_button btn btn-primary">
              ${window.translations.product.add_to_cart}
              <div class="svc-ico svc-ico--arrow"></div>
            </button>
          </form>
        </div>
      </div>
    `
    : ""

  const screen3 = `
    <div class="svc-card__screen svc-card__screen--3">
      <div class="svc-card__header svc-card__header--back">
        <div class="svc-card__service-ico"></div>

        <div class="svc-card__header-title">Select Service Type</div>

        <button class="svc-card__back">
          <div class="svc-ico svc-ico--close"></div>
        </button>
      </div>

      <div class="svc-card__subproducts" data-simplebar>
        ${renderSubproducts(product.subproducts || [], product.card_type)}
      </div>
    </div>
  `

  const instantScreen2 = product.card_type === "instant"
    ? `<div class="svc-card__screen svc-card__screen--2"></div>`
    : ""

  card.innerHTML = screen1 + screen2 + instantScreen2 + screen3

  return card
}


function initRecsSwipers() {

  const sliders = document.querySelectorAll('.swiper-recs')

  sliders.forEach(function (sliderEl, index) {

    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true)
    }

    var slides = sliderEl.querySelectorAll('.swiper-slide')
    var slideCount = slides.length
    var wrapper = sliderEl.querySelector('.swiper-wrapper')

    function getSlidesPerView() {
      let w = window.innerWidth
      if (w >= 1440) return 4
      if (w >= 1000) return 3
      if (w >= 768) return 2
      return 1
    }

    let slidesPerViewNow = getSlidesPerView()
    let enableLoop = slideCount > slidesPerViewNow

    if (!enableLoop) {
      sliderEl.classList.add('loop-disabled')
    } else {
      sliderEl.classList.remove('loop-disabled')
    }

    if (wrapper) {
      if (slideCount > 0 && slideCount < slidesPerViewNow) {
        wrapper.classList.add('swiper-wrapper--centered')
      } else {
        wrapper.classList.remove('swiper-wrapper--centered')
      }
    } else {
      console.warn("[swiper-recs] wrapper not found")
    }

    try {
      let swiper = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 24,
        loopFillGroupWithBlank: false,
        loop: enableLoop,
        pagination: {
          el: sliderEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: enableLoop ? {
          nextEl: sliderEl.querySelector('.swiper-button-next'),
          prevEl: sliderEl.querySelector('.swiper-button-prev'),
        } : {},
        breakpoints: {
          1440: { slidesPerView: 4 },
          1000: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          480: { slidesPerView: 1 },
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        }
      })

      swiper.on('touchStart', function () {
        swiper.autoplay && swiper.autoplay.stop()
      })

    } catch (e) {
      console.error("[swiper-recs] INIT ERROR:", e)
    }

  })

}

function initRecsSimplebars(scope = document) {
  const elements = scope.querySelectorAll('.svc-card__subproducts[data-simplebar]')

  elements.forEach(el => {
    if (!el.SimpleBar) {
      new SimpleBar(el)
    }
  })
}

function renderSlider(selector, products) {

  const slider = document.querySelector(selector)
  if (!slider) return

  const wrapper = slider.querySelector(".swiper-wrapper")
  if (!wrapper) return

  wrapper.innerHTML = ""

  products.forEach(product => {
    try {
      const slide = document.createElement("div")
      slide.className = "swiper-slide"

      const card = renderCard(product)

      slide.appendChild(card)
      wrapper.appendChild(slide)

    } catch (error) {
      console.error("[recs-render] renderCard error:", product, error)
    }
  })


  requestAnimationFrame(() => {
    initRecsSwipers()

    if (window.productCardManager) {
      window.productCardManager.initCards(slider)
    }

    requestAnimationFrame(() => {
      initRecsSimplebars(slider)
    })
  })
}

function initRecsRender() {
  if (!window.Recs) {
    return
  }

  let viewed = []
  let top = []

  try {
    viewed = window.Recs.viewed(8)
  } catch (error) {
    console.error("[recs-render] viewed error:", error)
  }

  try {
    top = window.Recs.topPicks(12)
  } catch (error) {
    console.error("[recs-render] topPicks error:", error)
  }

  try {
    renderSlider(".recs-viewed", viewed)
  } catch (error) {
    console.error("[recs-render] render .recs-viewed error:", error)
  }

  try {
    renderSlider(".recs-top", top)
  } catch (error) {
    console.error("[recs-render] render .recs-top error:", error)
  }

}

document.addEventListener("DOMContentLoaded", () => {
  initRecsRender()
})